import axios from "axios";

const http = axios.create({
    baseURL: process.env.VUE_APP_API_ENDPOINT,
    withCredentials: true,
});

http.defaults.headers.common = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
};

http.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


export default http;

const token = localStorage.getItem("token");
export const HTTP = axios.create({
    baseURL: process.env.VUE_APP_API_ENDPOINT,
    headers: {
        Authorization: `Bearer ${token}`
    }
})
